import React from 'react';
import CountryFlag from '../common/CountryFlag';
import './CalendarLegend.css';

const COUNTRY_COLORS = {
  US: '#3B82F6',
  DO: '#EF4444',
  TN: '#10B981',
  CO: '#F59E0B',
  VE: '#8B5CF6',
  AR: '#06B6D4',
  PT: '#EC4899',
};

function CalendarLegend({ countries, selectedCountry }) {
  const displayCountries = selectedCountry === 'all'
    ? countries
    : countries.filter(c => c.id === selectedCountry);

  return (
    <div className="calendar-legend">
      <div className="legend-group">
        <span className="legend-label">Holidays</span>
        {displayCountries.map(c => (
          <div key={c.id} className="legend-item">
            <CountryFlag code={c.code} size="small" />
            <span
              className="legend-dot"
              style={{ background: COUNTRY_COLORS[c.code] || '#6B7280' }}
            />
            <span className="legend-text">{c.name}</span>
          </div>
        ))}
      </div>
      <div className="legend-group">
        <span className="legend-label">Time Off</span>
        <div className="legend-item">
          <span className="legend-dot" style={{ background: '#10B981' }} />
          <span className="legend-text">Approved</span>
        </div>
        <div className="legend-item">
          <span className="legend-dot" style={{ background: '#F59E0B' }} />
          <span className="legend-text">Pending</span>
        </div>
      </div>
    </div>
  );
}

export default CalendarLegend;
